import { GuestType } from "@/types/guest";
import { BookingGuest } from "@/types/booking-guest";

export const formatEnumStatus = (status: string): string => {
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const calculateNightCount = (
  arrival: Date | string,
  departure: Date | string,
): number => {
  const arrivalDate = typeof arrival === "string" ? new Date(arrival) : arrival;
  const departureDate =
    typeof departure === "string" ? new Date(departure) : departure;

  const diffInMs = departureDate.getTime() - arrivalDate.getTime();

  return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
};

const pluralize = (count: number, singular: string, plural: string) =>
  `${count} ${count > 1 ? plural : singular}`;

export const formatGuestString = (additionalGuests: BookingGuest[] = []) => {
  const { adults: adultsCount, children: childrenCount } = calculateGuestsCount(additionalGuests);

  const adultsString = adultsCount ? pluralize(adultsCount, "adult", "adults") : "";
  const childrenString = childrenCount ? pluralize(childrenCount, "child", "children") : "";

  return [adultsString, childrenString].filter(Boolean).join(", ");
};


export const calculateGuestsCount = (additionalGuests: BookingGuest[] = []): { adults: number; children: number } => {
  return {
    adults:
      (additionalGuests?.filter(
        (bookingGuest) => bookingGuest.guest.guestType === GuestType.ADULT,
      )?.length || 0) + 1,
    children:
      additionalGuests?.filter((bookingGuest) => bookingGuest.guest.guestType === GuestType.CHILD)
        ?.length || 0,
  };
}